module.exports = __webpack_public_path__ + "img/foreign_icon.7334af29.svg";